(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-direct-discount-checkout]');
    if (!button) return;

    event.preventDefault();

    const state = button.closest('xo-product-will-change');
    if (state?.hasAttribute('xo-disabled')) return;

    const form = document.getElementById(button.dataset.productFormId);
    const variantId = form?.querySelector('input[name="id"]')?.value;
    const quantityInput = form?.elements?.namedItem('quantity');
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const discountCode = button.dataset.discountCode;

    if (!variantId || !discountCode) {
      window.location.assign(button.href);
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    const checkoutUrl = `${root}cart/${encodeURIComponent(variantId)}:${quantity}?discount=${encodeURIComponent(discountCode)}`;
    window.location.assign(checkoutUrl);
  });
  } catch(e) { console.error(e); }
})();

})();
